import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {saveAs} from 'file-saver';
import {firstValueFrom} from 'rxjs';
import {first} from 'rxjs/operators';

import {ExportSettingPickerDialogComponent} from '@atmi/shared';

import {SettingsClassName} from '../models';
import {SettingsApiService} from './settings-api.service';

@Injectable({
  providedIn: 'root',
})
export class UIExportService {

  constructor(
    private readonly dialog: MatDialog,
    private readonly settingsApi: SettingsApiService,
    private readonly snackBarService: MatSnackBar,
  ) {
  }

  async manageExport(
    handler: (template?: string, format?: string) => Promise<Blob>,
    className: SettingsClassName,
    exportFileName: string,
  ) {
    const layouts = this.settingsApi.selectStateSnapshot().system?.layouts;
    const layoutsAvailable = layouts?.filter((l) => l.className === className);
    let exportInfo: { format: string, layout: string } | undefined;

    if (layoutsAvailable && layoutsAvailable.length > 0) {
      const fileFormats = new Set(layoutsAvailable?.map((l) => l.fileFormat));
      const ref = this.dialog.open(ExportSettingPickerDialogComponent, {
        data: {
          fileFormats,
          layouts: layoutsAvailable,
        },
        maxHeight: '95vh',
        width: '400px',
      });
      exportInfo = await firstValueFrom(ref.afterClosed().pipe(first()));
      if (!exportInfo) {
        return;
      }
    }

    const undoSnackRef = this.snackBarService.open(`Esportazione in corso. L'operazione potrebbe richiedere qualche minuto.`);
    try {
      const blob = await handler(exportInfo?.layout, exportInfo?.format);
      saveAs(blob, exportFileName);
    } catch (e) {
      throw new Error(e);
    } finally {
      undoSnackRef.dismiss();
    }
  }
}
